export const getHTMLString = html => {
  const div = document.createElement('DIV');
  div.innerHTML = html;
  return div.textContent || div.innerText || '';
};
